import { type FC } from 'react';
import { RiAlertFill } from 'react-icons/ri';

interface ErrorFilterLinkProps {
  errorCount: number;
  onViewErrorsClick: () => void;
  testId?: string;
}

const ErrorFilterLink: FC<ErrorFilterLinkProps> = ({ errorCount, onViewErrorsClick, testId = 'view-errors-link' }) => {
  if (errorCount === 0) {
    return null;
  }

  return (
    <div className="flex items-center">
      <RiAlertFill className="red mr2" size={16} />
      <button className="link-button red" onClick={onViewErrorsClick} data-testid={testId}>
        View {errorCount} error{errorCount > 1 ? 's' : ''}
      </button>
    </div>
  );
};

export default ErrorFilterLink;
